import { render, staticRenderFns } from "./ManageRoute.vue?vue&type=template&id=204cdac2"
import script from "./ManageRoute.vue?vue&type=script&lang=js"
export * from "./ManageRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports